<template>
  <div class="d-flex flex-column pa-6 pa-md-0">
    <div class="d-flex align-center justify-center">
      <v-select
        label="ΑΕΔΑΚ"
        :items="banks"
        return-object
        v-model="currentCredInst"
        item-value="creditInstituteId"
        item-text="mmfManagerNationalName"
        @change="onChange"
        class="text-sm-body-1 mr-4"
        :style="'width:80px'"
      ></v-select>

      <v-btn
        fab
        x-small
        color="primary"
        class="mr-2"
        @click="editCredInstDialog = true"
        :disabled="currentCredInst == null"
      >
        <v-icon> mdi-pencil </v-icon>
      </v-btn>
      <v-btn
        fab
        x-small
        color="error"
        @click="deleteCredInstDialog = true"
        :disabled="currentCredInst == null"
      >
        <v-icon> mdi-delete </v-icon>
      </v-btn>
    </div>

    <v-btn
      class="success rounded text-sm-body-1 font-weight-regular align-self-end mb-8 mt-8"
      @click="addCredInstDialog = true"
    >
      <v-icon>mdi-plus</v-icon> <span>Προσθήκη</span>
    </v-btn>

    <div class="d-flex align-center">
      <v-select
        label="Κεφάλαια"
        :items="funds"
        return-object
        item-text="mmfNationalName"
        item-value="mmfId"
        v-model="currentFund"
        class="text-sm-body-1 mr-4"
      ></v-select>

      <v-btn
        fab
        x-small
        color="primary"
        class="mr-2"
        @click="editFundDialog = true"
        :disabled="currentFund == null"
      >
        <v-icon> mdi-pencil </v-icon>
      </v-btn>
      <v-btn
        fab
        x-small
        color="error"
        @click="deleteFundDialog = true"
        :disabled="currentFund == null"
      >
        <v-icon> mdi-delete </v-icon>
      </v-btn>
    </div>

    <v-btn
      class="success rounded text-sm-body-1 font-weight-regular align-self-end mb-8 mt-8"
      @click="addFundDialog = true"
    >
      <v-icon>mdi-plus</v-icon> <span>Προσθήκη</span>
    </v-btn>

    <v-simple-table class="table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-sm-body-1 font-weight-bold">Όνομα</th>
            <th class="text-sm-body-1 font-weight-bold">Επίθετο</th>
            <th class="text-sm-body-1 font-weight-bold">Email</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, i) in users" :key="i">
            <td class="text-sm-body-1">
              {{ user.user.firstName }}
            </td>

            <td class="text-sm-body-1">
              {{ user.user.lastName }}
            </td>

            <td class="text-sm-body-1">
              {{ user.user.userEmail }}
            </td>

            <td>
              <v-btn
                class="mr-2"
                color="primary"
                fab
                x-small
                @click="
                  currentUser = user;
                  editEmployeeDialog = true;
                "
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                color="error"
                fab
                x-small
                @click="
                  currentUser = user;
                  deleteEmployeeDialog = true;
                "
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn
                @click="changePassword(user)"
                class="ml-2"
                color="primary"
                style="text-transform: none"
              >
                Αλλαγή Κωδικού
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-btn
      class="success rounded text-sm-body-1 font-weight-regular align-self-end mb-8 mt-8"
      @click="addEmployeeDialog = true"
    >
      <v-icon>mdi-plus</v-icon> <span>Προσθήκη</span>
    </v-btn>

    <v-dialog max-width="600px" v-model="addCredInstDialog">
      <AddCreditInstitute
        v-if="addCredInstDialog"
        @closeDialog="addCredInstDialog = false"
        @getCreditInstitutes="getCreditInstitutes"
      />
    </v-dialog>

    <v-dialog max-width="600px" v-model="editCredInstDialog">
      <EditCreditInstitute
        v-if="editCredInstDialog"
        :currentCreditInstitute="currentCredInst"
        @closeDialog="editCredInstDialog = false"
        @getCreditInstitutes="getCreditInstitutes"
      />
    </v-dialog>

    <v-dialog max-width="600px" v-model="deleteCredInstDialog">
      <DeleteCreditInstitute
        v-if="deleteCredInstDialog"
        :currentCreditInstitute="currentCredInst"
        @closeDialog="deleteCredInstDialog = false"
        @getCreditInstitutes="getCreditInstitutes()"
      />
    </v-dialog>

    <v-dialog max-width="600px" v-model="addFundDialog">
      <AddFund
        v-if="addFundDialog"
        :fund="currentFund"
        :currentCreditInstitute="currentCredInst"
        @closeDialog="addFundDialog = false"
        @getCreditInstitutes="getCreditInstitutes()"
      />
    </v-dialog>

    <v-dialog max-width="600px" v-model="editFundDialog">
      <EditFund
        v-if="editFundDialog"
        :fund="currentFund"
        @closeDialog="editFundDialog = false"
        :currentCreditInstitute="currentCredInst"
        @getCreditInstitutes="getCreditInstitutes()"
      />
    </v-dialog>

    <v-dialog max-width="600px" v-model="deleteFundDialog">
      <DeleteFund
        v-if="deleteFundDialog"
        :fund="currentFund"
        @closeDialog="deleteFundDialog = false"
        :currentCreditInstitute="currentCredInst"
        @getCreditInstitutes="getCreditInstitutes()"
      />
    </v-dialog>

    <v-dialog max-width="700px" v-model="addEmployeeDialog">
      <AddEmployee
        v-if="addEmployeeDialog"
        @closeDialog="addEmployeeDialog = false"
        :currentCreditInstitute="currentCredInst"
        @getUsers="getUsers(currentCredInst.creditInstituteId)"
      />
    </v-dialog>

    <v-dialog max-width="700px" v-model="editEmployeeDialog">
      <EditEmployee
        v-if="editEmployeeDialog"
        @closeDialog="editEmployeeDialog = false"
        :currentUser="currentUser"
        :currentCreditInstitute="currentCredInst"
        @getUsers="getUsers(currentCredInst.creditInstituteId)"
      />
    </v-dialog>

    <v-dialog max-width="500px" v-model="deleteEmployeeDialog">
      <DeleteEmployee
        v-if="deleteEmployeeDialog"
        @closeDialog="deleteEmployeeDialog = false"
        :currentUser="currentUser"
        @getUsers="getUsers(currentCredInst.creditInstituteId)"
      />
    </v-dialog>

    <v-dialog v-model="changePasswordDialog">
      <ChangePassword
        :currentCreditInstitute="currentCredInst"
        v-if="changePasswordDialog"
        @closeDialog="changePasswordDialog = false"
        :currentUser="currentUser"
        @getUsers="getUsers(currentCredInst.creditInstituteId)"
      />
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

import AddCreditInstitute from "../../components/Modals/CredInst/AddCreditInstitute.vue";
import EditCreditInstitute from "../../components/Modals/CredInst/EditCreditInstitute.vue";
import DeleteCreditInstitute from "../../components/Modals/CredInst/DeleteCreditInstitue.vue";

import AddFund from "../../components/Modals/Funds/AddFund.vue";
import EditFund from "../../components/Modals/Funds/EditFund.vue";
import DeleteFund from "../../components/Modals/Funds/DeleteFund.vue";

import AddEmployee from "../../components/Modals/Employee/AddEmployee.vue";
import EditEmployee from "../../components/Modals/Employee/EditEmployee.vue";
import DeleteEmployee from "../../components/Modals/Employee/DeleteEmployee.vue";
import ChangePassword from "@/components/Modals/ChangePassword.vue";

export default {
  components: {
    AddCreditInstitute,
    EditCreditInstitute,
    DeleteCreditInstitute,
    AddFund,
    EditFund,
    DeleteFund,
    AddEmployee,
    EditEmployee,
    DeleteEmployee,
    ChangePassword,
  },

  async created() {
    await this.getCreditInstitutes();
  },

  data() {
    return {
      banks: [],
      users: [],

      currentFund: null,
      currentUser: null,
      currentCredInst: null,

      addCredInstDialog: false,
      editCredInstDialog: false,
      deleteCredInstDialog: false,

      addFundDialog: false,
      editFundDialog: false,
      deleteFundDialog: false,

      addEmployeeDialog: false,
      editEmployeeDialog: false,
      deleteEmployeeDialog: false,

      changePasswordDialog: false,
    };
  },

  computed: {
    funds() {
      if (this.currentCredInst != null) return this.currentCredInst.funds;
      else return [];
    },
  },

  methods: {
    async getCreditInstitutes() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/admin/GetCreditInstitutes`
        );
        this.banks = res.data;

        //edit case
        if (this.currentCredInst != null) {
          this.currentCredInst = this.banks.find(
            (el) =>
              el.creditInstituteId == this.currentCredInst?.creditInstituteId
          );
          this.currentFund = this.funds.find(
            (el) => el.mmfId == this.currentFund?.mmfId
          );

          //delete case
          if (this.currentCredInst != null)
            await this.getUsers(this.currentCredInst?.creditInstituteId);
          else this.users = [];

          return;
        } else {
          //created case
          this.currentCredInst = this.banks[0];
          this.currentFund = this.banks[0]?.funds[0];
          await this.getUsers(this.currentCredInst?.creditInstituteId);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getUsers(bankId) {
      try {
        const result = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/system/CreditInstituteEmployees/${bankId}`
        );
        this.users = result.data;
      } catch (e) {
        console.log(e);
      }
    },

    async onChange() {
      await this.getUsers(this.currentCredInst.creditInstituteId);
      this.currentFund = this.currentCredInst.funds[0];
    },

    async changePassword(user) {
      this.currentUser = user;
      this.changePasswordDialog = true;
      // this.$store.commit("toggleSnackbar", {
      //   open: true,
      //   color: "success",
      //   text: "Η αλλαγή κωδικού ολοκληρώθηκε με επιτυχία.",
      // });
    },
  },
};
</script>

<style scoped lang="scss">
.table {
  width: 800px;
}

@media only screen and (max-width: 960px) {
  .table {
    width: 600px !important;
  }
}

@media only screen and (max-width: 600px) {
  .table {
    width: 350px !important;
  }
}
</style>